export default __webpack_public_path__ + "static/media/checked.9a92ecfe.svg";